import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M39.2008 19.9969C39.2008 30.6007 30.6046 39.1969 20.0008 39.1969C9.39694 39.1969 0.800781 30.6007 0.800781 19.9969C0.800781 9.39304 9.39694 0.796875 20.0008 0.796875C30.6046 0.796875 39.2008 9.39304 39.2008 19.9969Z",
      stroke: "#AA1E2D",
      "stroke-width": "1.6"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 19.6083L17.8454 25.4536L28.0998 15.1992",
      stroke: "#AA1E2D",
      "stroke-width": "1.6"
    }, null, -1)
  ])))
}
export default { render: render }